import { render, staticRenderFns } from "./ModerationView.vue?vue&type=template&id=aba74876"
import script from "./ModerationView.vue?vue&type=script&lang=js"
export * from "./ModerationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports